export default __webpack_public_path__ + "static/media/SKS_Doctor.64a1aa37.svg";